/** @jsxImportSource @emotion/react */
import type { ReactNode } from 'react';
import { buttonStyle } from './Button.styles';

/** 형태. admin-mockup에서 outline(새로고침·수정), text(이력·상세) 확인되어 확장. */
export type ButtonVariant = 'solid' | 'outline' | 'text';
/** 색 계열. danger는 실행 취소 버튼, neutral은 보조 버튼에서 확인. */
export type ButtonTone = 'primary' | 'danger' | 'neutral';

export interface ButtonProps {
  variant?: ButtonVariant;
  tone?: ButtonTone;
  /** 글자 왼쪽 아이콘 자리. */
  icon?: ReactNode;
  disabled?: boolean;
  /** 버튼 타입. form 내에서 submit 필요할 때 사용. */
  type?: 'button' | 'submit' | 'reset';
  children: ReactNode;
  onClick?: () => void;
}

/** 액션 버튼. 주 액션(지금 수집), 보조 액션(새로고침·수정), 행 내 링크형(상세·이력)에 활용. */
export function Button({
  variant = 'solid',
  tone = 'primary',
  icon,
  disabled,
  type = 'button',
  children,
  onClick,
}: ButtonProps) {
  return (
    <button type={type} css={buttonStyle(variant, tone)} disabled={disabled} onClick={onClick}>
      {icon}
      {children}
    </button>
  );
}
